import toaster from 'utility/toaster'

const htmx = {
  events() {
    document.addEventListener('htmx:responseError', (e: Event & { detail: any }) => {
      e.stopImmediatePropagation()
      const statusCode = e.detail.xhr.status

      if (statusCode === 404) {
        toaster.error('Page not found (404)')
      } else if (statusCode === 500) {
        toaster.error('Server error (500)')
      } else {
        toaster.error(`HTMX error with status code: ${statusCode}`)
      }
      e.stopPropagation()
    })
  },
}

export default htmx
